'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProductAvailability = undefined;
exports.getAvailabilityColor = getAvailabilityColor;
exports.getAvailabilityText = getAvailabilityText;

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App');

var ProductAvailability = exports.ProductAvailability = {
    /// <summary>
    /// Nelze dat do kosiku ani pridat hlidaciho psa
    /// </summary>
    Unavailable: 0,

    /// <summary>
    /// Skladem, ihned k expedici
    /// </summary>
    Available: 1,

    /// <summary>
    /// Pripravujeme
    /// </summary>
    ComingSoon: 2,

    /// <summary>
    /// Delsi dodaci lhuta, lze dat do kosiku
    /// </summary>
    LongerDelivery: 3,

    /// <summary>
    /// Zbozi neni na sklade, lze pridat hlidaciho psa
    /// </summary>
    OutOfStock: 4,

    /// <summary>
    /// Expedujeme v konkrétní datum, lze dat do kosiku
    /// </summary>
    ExactDelivery: 5
};

function getAvailabilityColor(value) {
    switch (value) {
        case ProductAvailability.Available:
        case ProductAvailability.LongerDelivery:
        case ProductAvailability.ExactDelivery:
            return 'green';
        case ProductAvailability.ComingSoon:
        case ProductAvailability.OutOfStock:
            return 'orange';
        case ProductAvailability.Unavailable:
            return 'red';
    }
    return '';
}

// isInStock ? Resx.App.AmountInStock : Resx.App.ProductUnsaleable
function getAvailabilityText(value) {
    var inCart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    switch (value) {
        case ProductAvailability.Unavailable:
            return Resx.App.ProductUnsaleable;
        case ProductAvailability.Available:
            return Resx.App.AmountInStock;
        case ProductAvailability.ComingSoon:
            return Resx.App.ComingSoon;
        case ProductAvailability.LongerDelivery:
            return inCart ? Resx.App.LongerDelivery_Detail : Resx.App.LongerDelivery;
        case ProductAvailability.ExactDelivery:
            return Resx.App.ExactDelivery;
        case ProductAvailability.OutOfStock:
            return Resx.App.OutOfStock;
    }
    return '';
}

exports.default = {
    ProductAvailability: ProductAvailability,
    getAvailabilityColor: getAvailabilityColor,
    getAvailabilityText: getAvailabilityText
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/productAvailability.js
// module id = 469
// module chunks = 0